// The backend serializes timestamps as `yyyy-MM-dd HH:mm:ssZ` (space instead of `T`),
// which is not a valid ISO 8601 string: Chrome parses it by leniency, other engines
// may return `Invalid Date`. Normalize it before handing the value to `Date`.
const SERVER_DATE_TIME =
  /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})(:\d{2})?(\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/;

export const toIsoDateTime = (value?: string | null): string | null => {
  if (!value) {
    return null;
  }
  const match = SERVER_DATE_TIME.exec(value.trim());
  if (!match) {
    return value;
  }
  const [, date, hoursAndMinutes, seconds, milliseconds, zone] = match;
  return `${date}T${hoursAndMinutes}${seconds ?? ':00'}${milliseconds ?? ''}${zone ?? 'Z'}`;
};

export const parseServerDate = (value?: string | null): Date | null => {
  const isoDateTime = toIsoDateTime(value);
  if (!isoDateTime) {
    return null;
  }
  const parsed = new Date(isoDateTime);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const parseServerTimestamp = (value?: string | null): number => {
  const parsed = parseServerDate(value);
  return parsed ? parsed.getTime() : 0;
};
